require('./hireCreditLimit.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');
const { connect } = require('react-redux');

// @ helpers
const { formatText, getLanguage } = require('core/i18n').i18n;
const { formatAmount } = require('utilities/currencyHelper');

// @ commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const OKSliderInput = require('commonsComponents/OKSliderInput');

// @ components
const HireCreditLimitModal = require('components/hire/hireCreditLimitModal/hireCreditLimitModal');

// @ actions
const hireCreditLimitActions = require('actions/hireCreditLimit');
const hireCreditCardActions = require('actions/hireCreditCard');

// @ constants
const {
    EURO_SYMBOL
} = require('constants/index');

class HireCreditLimit extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const {
            defaultLimit,
            getHireCreditLimit,
            immHireCreditLimit,
            productSubType,
            productType,
            referenceStandard,
        } = this.props;

        if (!immHireCreditLimit.get('fetchSuccess') ||
            productSubType !== immHireCreditLimit.get('productSubType') ||
            productType !== immHireCreditLimit.get('productType') ||
            referenceStandard !== immHireCreditLimit.get('referenceStandard')
        ) {
            getHireCreditLimit(productType, productSubType, referenceStandard, defaultLimit);
        }
    }

    render() {
        const {
            handleCreditLimitChange,
            handleCreditLimitModalValueChange,
            handleModalContinue,
            handleToggleModal,
            immHireCreditLimit,
            immHirePaymentMethod,
        } = this.props;
        const creditLimit = immHireCreditLimit.get('creditLimit');
        let sliderElement;

        if (immHireCreditLimit.get('isFetching')) {
            sliderElement = <LoadingSection />;
        } else if (immHireCreditLimit.get('fetchSuccess')) {
            const title = formatText('hireCreditLimitComponent-creditLimit');
            const minValue = immHireCreditLimit.get('minValue');
            const minLabel = `${formatText('hireCreditLimitComponent-minLabel')} ${formatAmount(minValue, getLanguage(), 0)}`;
            const maxValue = immHireCreditLimit.get('maxValue');
            const maxLabel = `${formatText('hireCreditLimitComponent-maxLabel')} ${formatAmount(maxValue, getLanguage(), 0)}`;
            const sliderMarks = immHireCreditLimit.get('marks');

            sliderElement = (
                <section className="hire-credit-limit__slider-container col-xs-12">
                    <OKSliderInput
                        defaultValue={creditLimit}
                        marks={sliderMarks}
                        maxLabel={maxLabel}
                        minLabel={minLabel}
                        onChange={handleCreditLimitChange}
                        title={title}
                        unit={EURO_SYMBOL}
                    />
                    <HireCreditLimitModal
                        creditLimit={immHireCreditLimit.get('creditLimit')}
                        creditLimitModalValue={immHireCreditLimit.get('creditLimitModalValue')}
                        immHirePaymentMethod={immHirePaymentMethod}
                        maxValueToAuthorize={immHireCreditLimit.get('maxValueToAuthorize')}
                        onRequestClose={() => handleToggleModal(false)}
                        onRequestContinue={handleModalContinue}
                        openModal={immHireCreditLimit.get('modalIsOpen')}
                        handleCreditLimitModalValueChange={handleCreditLimitModalValueChange}
                    />
                </section>
            );
        }

        return (
            <article className="hire-credit-limit row">
                {sliderElement}
            </article>
        );
    }
}

HireCreditLimit.propTypes = {
    defaultLimit: PropTypes.number,
    getHireCreditLimit: PropTypes.func.isRequired,
    handleCreditLimitChange: PropTypes.func.isRequired,
    handleCreditLimitModalValueChange: PropTypes.func.isRequired,
    handleModalContinue: PropTypes.func.isRequired,
    handleToggleModal: PropTypes.func.isRequired,
    immHireCreditLimit: PropTypes.object.isRequired,
    immHirePaymentMethod: PropTypes.object.isRequired,
    productSubType: PropTypes.string.isRequired,
    productType: PropTypes.string.isRequired,
    referenceStandard: PropTypes.string.isRequired,
};

module.exports.constructor = HireCreditLimit;

module.exports.HireCreditLimit = connect(null,
    {
        getHireCreditLimit: hireCreditLimitActions.getHireCreditLimit,
        handleCreditLimitChange: hireCreditLimitActions.setHireCreditLimit,
        handleCreditLimitModalValueChange: hireCreditLimitActions.setHireCreditLimitModalValue,
        handleToggleModal: hireCreditLimitActions.toggleModal,
        newHandleCreditCardLimitChange: hireCreditCardActions.setHireCreditCardLimit,
    }
)(HireCreditLimit);

